import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const ReviewTab = () => {
  return (
    <div>
      <section className="">
        <Row className="my-lg-4 my-2 pt-3 justify-content-center margin_bottomfooter mb-5">
          <Col lg={12} xxl={11}>
            <Row>
              <Col xs={12} className="mb-0">
                <div className="comments_safari operator_comment bg-white">
                 <div className="commentsOther  position-relative px-5 pt-4">
                    <div className=" d-flex justify-content-between flex-wrap">
                        <div className="whiteReview mt-2">
                            <Link to="" className="parkrevieBtn py-2">Please Login to Review</Link>
                        </div>
                    </div>
                 </div>
                 <div className="review-list"></div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default ReviewTab;
